import { savePreferences } from '@/redux/slices/authSlice';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { selectCurrentTableKey } from '@/redux/selectors/dataTableSelectors';
import { selectUserPreferences } from '@/redux/selectors/authSelectors';
import { FilterLayoutsFilter } from '@/redux/slices/slice_types';

export const useSaveFiltersSettings = () => {
  const dispatch = useAppDispatch();
  const tableKey = useAppSelector(selectCurrentTableKey);
  const userPrefs = useAppSelector(selectUserPreferences);

  return (updatedFilterLayouts: FilterLayoutsFilter[]) => {
    if (!tableKey) return;

    return dispatch(
      savePreferences({
        [tableKey]: {
          ...userPrefs[tableKey],
          filters: updatedFilterLayouts
        }
      })
    ).unwrap();
  };
};
